module.exports = __webpack_public_path__ + "static/media/7D.d00ed5bc.svg";